<template>
  <CCard>
    <CCardHeader>
      <div class="card-header-actions">
        <CButton variant="outline" color="success" @click="onReset" ref="reset-button" v-translate
                 translate-context="form" class="mr-2">Reset
        </CButton>
        <CButton color="primary" @click="onSave" ref="save-button">{{ save_text }}</CButton>
      </div>
    </CCardHeader>
    <CCardBody class="p-0">
      <CContainer fluid class="grid-stripped">
        <PFRow :label="$pgettext('region.label', 'Name')">
          <PTranslatableTextInput v-model="form.name"/>
        </PFRow>
        <PFRow :label="$pgettext('region.label', 'Code')">
          <CInput v-model="form.code" :placeholder="$pgettext('region.placeholder','Code')"/>
        </PFRow>
        <PFRow :label="$pgettext('region.label', 'Currency')">
          <CurrencySelect v-model="form.currency"/>
        </PFRow>
        <PFRow :label="$pgettext('region.label', 'Countries')">
          <CountrySelect v-model="form.countries"/>
        </PFRow>
        <PFRow :label="$pgettext('region.label', 'Is Public')">
          <CSwitch class="mx-1" color="primary" variant="3d" size="sm" :checked.sync="form.is_public"/>
        </PFRow>
        <PFRow :label="$pgettext('region.label', 'Flag')" v-if="get_flag_upload_intent">
          <PUploader
            :params="uploadParams.flag"
            :get_intent="get_flag_upload_intent"
            :value.sync="form.flag"
            :preview="flag_url"
            @uploaded="newFlagUploaded"
          />
        </PFRow>
      </CContainer>
    </CCardBody>
  </CCard>

</template>

<script>
import PFRow from "@/domain/core/components/PFRow.vue";
import CurrencySelect from "@/domain/core/components/CurrencySelect.vue";
import CountrySelect from "@/domain/core/components/CountrySelect.vue";
import PTranslatableTextInput from "@/domain/core/components/PTranslatableTextInput.vue";
import PUploader from "@/domain/core/components/PUploader.vue";
import {isUploadIntent, DELETE_KEY} from "@/domain/core/components/uploader";

export default {
  name: "Form",
  components: {PUploader, PTranslatableTextInput, CurrencySelect, CountrySelect, PFRow},
  props: {
    data: {
      type: Object,
      required: true
    },
    save_text: {
      type: String,
      required: true
    },
    get_flag_upload_intent: {
      type: Function,
      required: false,
    },
    get_upload_intent_public_url: {
      type: Function,
      required: false,
    },
  },
  data() {
    return {
      loading: true,
      flag_url: null,
      form: {
        name: {},
        code: '',
        currency: '',
        countries: [],
        is_public: false,
        flag: null,
      },
    }
  },
  async mounted() {
    this.onReset()
  },
  emits: ['save'],
  computed: {
    uploadParams() {
      return {
        flag: {allowed_extensions: ['jpg', 'jpeg', 'png']},
      }
    },
  },
  methods: {
    onReset() {
      this.form = {...this.data}
      this.flag_url = this.data.flag || null
    },
    async onSave() {
      this.$emit('save', this.form)
    },
    async newFlagUploaded() {
      await this.$nextTick()
      if (this.form.flag === DELETE_KEY)
        this.flag_url = ''
      else if (isUploadIntent(this.form.flag)) {
        this.flag_url = await this.get_upload_intent_public_url(this.form.flag)
      }
    },
  }
}
</script>